import { Fragment } from "react";

import ProductCard from "../Helpers/ProductCard";
import AirFooterBannerInfo from "./AirFooterBannerInfo";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

const AirBannerInfo = ({ data, language, t, products: myProducts = [] }) => {
    const products = myProducts.map((product) =>
        product?._source ? product?._source : product
    );
    return (
        <>
            <h2 className="mb-2 font-bold text-[22px] max-[768px]:text-base">
                {data[`title-${language}`]}
            </h2>
            {data?.image_url ? (
                <AirFooterBannerInfo
                    imgPath={
                        language === "en" ? data?.image_url : data?.image_ar_url
                    }
                />
            ) : null}
            {products.length === 5 ? (
                <div className="grid grid-cols-5 gap-4 my-5 max-[768px]:my-3 max-[768px]:grid-cols-1">
                    {products.map((product, i) => (
                        <ProductCard product={product} t={t} key={i} />
                    ))}
                </div>
            ) : products.length === 4 ? (
                <div className="grid grid-cols-4 gap-4 my-5 max-[768px]:my-3 max-[768px]:grid-cols-1">
                    {products.map((product, i) => (
                        <ProductCard product={product} t={t} key={i} />
                    ))}
                </div>
            ) : products.length === 3 ? (
                <>
                    <div className="grid grid-cols-2 gap-2 my-5 max-[768px]:grid-cols-1 max-[768px]:my-3">
                        {products.slice(0, 2).map((product, i) => (
                            <ProductCard
                                fromTopTen
                                product={product}
                                t={t}
                                key={i}
                            />
                        ))}
                    </div>
                    <div className="grid w-1/2 grid-cols-1 gap-2 mx-auto my-5 max-[768px]:w-full max-[768px]:my-3">
                        {products.slice(2, 3).map((product, i) => (
                            <ProductCard
                                fromTopTen
                                product={product}
                                t={t}
                                key={i}
                            />
                        ))}
                    </div>
                </>
            ) : products.length === 2 ? (
                <div className="grid grid-cols-2 gap-2 my-5 max-[768px]:grid-cols-1 max-[768px]:my-3">
                    {products.map((product, i) => (
                        <ProductCard
                            fromTopTen
                            product={product}
                            t={t}
                            key={i}
                        />
                    ))}
                </div>
            ) : products.length === 1 ? (
                <div className="grid w-1/2 grid-cols-1 gap-2 mx-auto my-5 max-[768px]:w-full max-[768px]:my-3">
                    {products.map((product, i) => (
                        <ProductCard
                            fromTopTen
                            product={product}
                            t={t}
                            key={i}
                        />
                    ))}
                </div>
            ) : null}
            {/* sdaadsdasds */}
            <p
                className="mt-3 mb-6 max-[768px]:text-sm"
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(data[`description-${language}`]),
                }}
            />
            {data?.q_a.map((info, i) => (
                <Fragment key={i}>
                    <h3 className="mb-2 text-lg font-bold max-[768px]:text-base">
                        {info[`question_${language}`]}
                    </h3>
                    <p className="mt-3 mb-6 max-[768px]:text-sm">
                        {info[`answer_${language}`]}
                    </p>
                </Fragment>
            ))}
        </>
    );
};

export default AirBannerInfo;
